'use strict';

exports.__esModule = true;
exports.CallRequestButton = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _class, _temp; // import {
//   user as userQuery,
// } from "query";
// import UserLink from "ui/Link/User";


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _IconButton = require('material-ui/IconButton');

var _IconButton2 = _interopRequireDefault(_IconButton);

var _withStyles = require('material-ui/styles/withStyles');

var _withStyles2 = _interopRequireDefault(_withStyles);

var _context5 = require('@prisma-cms/context');

var _context6 = _interopRequireDefault(_context5);

var _reactApollo = require('react-apollo');

var _CallEnd = require('material-ui-icons/CallEnd');

var _CallEnd2 = _interopRequireDefault(_CallEnd);

var _Call = require('material-ui-icons/Call');

var _Call2 = _interopRequireDefault(_Call);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }

        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }

      return step("next");
    });
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
/**
 * ToDo: Надо сделать, чтобы можно было видеть несколько входящих окон
 */


var styles = {
  root: {// position: "relative",
  },
  inner: {},
  // alert: {
  //   // position: "absolute",
  //   ["&.cAlert--alert"]: {
  //     // top: 100,
  //     // right: 40,
  //     "@media (max-width: 440px)": {
  //       right: 0,
  //       // left: 0,
  //     },
  //   },
  // },
  button: {
    backgroundColor: "white",
    height: 40,
    width: 40
  }
};
var CallRequestButton = exports.CallRequestButton = (_temp = _class = function (_Component) {
  _inherits(CallRequestButton, _Component);

  function CallRequestButton() {
    _classCallCheck(this, CallRequestButton);

    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  CallRequestButton.prototype.closeCall = function () {
    var _ref = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee(callRequestId) {
      var status = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "Ended";

      var _context, updateCallRequest, connections, connection;

      return _regenerator2.default.wrap(function _callee$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              // const {
              //   connection,
              //   // streams,
              // } = this.props;
              _context = this.context, updateCallRequest = _context.updateCallRequest, connections = _context.connections;

              if (!callRequestId) {
                _context2.next = 4;
                break;
              }

              _context2.next = 4;
              return updateCallRequest(callRequestId, {
                status: status
              });

            case 4:
              connection = connections && connections[0] || null;
              connection && connection.close();

            case 6:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee, this);
    }));

    function closeCall(_x) {
      return _ref.apply(this, arguments);
    }

    return closeCall;
  }();

  CallRequestButton.prototype.cancelCall = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regenerator2.default.mark(function _callee2(callRequestId) {
      return _regenerator2.default.wrap(function _callee2$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              return _context3.abrupt('return', this.closeCall(callRequestId, "Canceled"));

            case 1:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee2, this);
    }));

    function cancelCall(_x3) {
      return _ref2.apply(this, arguments);
    }

    return cancelCall;
  }();

  CallRequestButton.prototype.render = function render() {
    var _this2 = this; // return "CallRequest";


    var _context4 = this.context,
        Avatar = _context4.Avatar,
        UserLink = _context4.UserLink,
        currentUser = _context4.user,
        Grid = _context4.Grid,
        ChatRoomLink = _context4.ChatRoomLink;
    var _props = this.props,
        classes = _props.classes,
        accept = _props.accept,
        reject = _props.reject,
        callRequest = _props.item;

    var _ref3 = currentUser || {},
        currentUserId = _ref3.id;

    if (!currentUserId) {
      return null;
    } // const {
    //   loading,
    //   callRequest,
    // } = data;
    // if (!callRequest || loading) {
    //   return null;
    // }


    if (!callRequest) {
      return null;
    }

    var callRequestId = callRequest.id,
        Caller = callRequest.Caller,
        status = callRequest.status,
        Called = callRequest.Called,
        Room = callRequest.Room;
    var callerId = Caller.id;
    var calledId = Called.id;
    var button = null;

    switch (status) {
      case "Created":
        if (calledId === currentUserId) {
          // const __button = <div
          //   className={["cAlert testArea opened", classes.root].join(" ")}
          // >
          //   <audio
          //     key="callingRington"
          //     src="/media/call.mp3"
          //     autoPlay
          //     loop
          //   // controls
          //   />
          //   <div
          //     className={[classes.inner].join(" ")}
          //   >
          //     <div
          //       className={["cAlert--alert", classes.alert].join(" ")}
          //     >
          //       {Caller ?
          //         <UserLink
          //           user={Caller}
          //         /> : null
          //       }
          //       <div className="alertMessage">
          //         <div className="message">Is calling you</div>{/* Звонит Вам */}
          //         <div className="loading"><span className="aml1"></span><span className="aml2"></span><span className="aml3"></span></div>
          //       </div>
          //       <div className="alertControls">
          //         <button
          //           type="button" className="button transition-03 smooth btnDecline"
          //           onClick={reject}
          //         >
          //           <i className="icon fal fa-remove"></i>Decline{/* Отменить */}
          //         </button>
          //         <button
          //           type="button" className="button transition-03 smooth btnAccept"
          //           onClick={accept}
          //         >
          //           <i className="icon fal fa-video"></i>Accept{/* Принять */}
          //         </button>
          //         {/* <button type="button" className="button transition-03 smooth btnAcceptTwo"><span>Accept without video</span></button>Принять без видео */}
          //       </div>
          //     </div>
          //   </div>
          // </div>;
          button = _react2.default.createElement(Grid, {
            container: true,
            alignItems: 'center'
          }, _react2.default.createElement(Grid // className={[classes.inner].join(" ")}
          , {
            item: true
          }, _react2.default.createElement('audio', {
            key: 'callingRington',
            src: '/media/call.mp3',
            autoPlay: true,
            loop: true // controls

          }), Caller ? _react2.default.createElement(UserLink, {
            user: Caller
          }) : null), _react2.default.createElement(Grid // className={[classes.inner].join(" ")}
          , {
            item: true
          }, _react2.default.createElement(_IconButton2.default, {
            className: [classes.button].join(" "),
            color: 'primary',
            onClick: accept // style={{
            //   backgroundColor: "white",
            // }}

          }, _react2.default.createElement(_Call2.default, null))), _react2.default.createElement(Grid // className={[classes.inner].join(" ")}
          , {
            item: true
          }, _react2.default.createElement(_IconButton2.default, {
            className: [classes.button].join(" "),
            color: 'secondary',
            onClick: reject
          }, _react2.default.createElement(_CallEnd2.default, null))));
        } else if (callerId === currentUserId) {
          button = _react2.default.createElement(Grid, {
            container: true,
            alignItems: 'center'
          }, _react2.default.createElement(Grid // className={[classes.inner].join(" ")}
          , {
            item: true
          }, _react2.default.createElement(_IconButton2.default, {
            className: [classes.button].join(" "),
            color: 'secondary',
            onClick: function onClick(event) {
              // callUser("cjdp665565yho01119wymwezk");
              _this2.cancelCall(callRequestId);
            }
          }, _react2.default.createElement(_CallEnd2.default, null))));
        }

        break;

      case "Started":
        if (calledId === currentUserId || callerId === currentUserId) {
          // button = <div
          //   className={["cAlert testArea opened", classes.root].join(" ")}
          // >
          //   <div
          //     className={[classes.inner].join(" ")}
          //   >
          //     {Caller ?
          //       <UserLink
          //         user={Caller}
          //       /> : null
          //     }
          //     <div className="alertControls">
          //       <button
          //         type="button" className="button transition-03 smooth btnDecline"
          //         onClick={event => {
          //           // callUser("cjdp665565yho01119wymwezk");
          //           this.closeCall(callRequestId);
          //         }}
          //       >
          //         <i className="icon fal fa-remove"></i> Завершить
          //         </button>
          //       {/* <button type="button" className="button transition-03 smooth btnAcceptTwo"><span>Accept without video</span></button>Принять без видео */}
          //     </div>
          //   </div>
          // </div>
          var User = void 0;

          if (calledId === currentUserId) {
            User = Caller;
          } else if (callerId === currentUserId) {
            User = Called;
          }

          button = _react2.default.createElement(Grid, {
            container: true,
            alignItems: 'center'
          }, _react2.default.createElement(Grid, {
            item: true
          }, User ? _react2.default.createElement(UserLink, {
            user: User
          }) : null), _react2.default.createElement(Grid, {
            item: true
          }, Room ? _react2.default.createElement(ChatRoomLink, {
            object: Room
          }) : null), _react2.default.createElement(Grid, {
            item: true
          }, _react2.default.createElement(_IconButton2.default, {
            className: [classes.button].join(" "),
            color: 'secondary',
            onClick: function onClick(event) {
              _this2.closeCall(callRequestId);
            }
          }, _react2.default.createElement(_CallEnd2.default, null))));
        }

        break;
    }

    return button;
  };

  return CallRequestButton;
}(_react.Component), _class.contextType = _context6.default, _temp); // export default graphql(userQuery, {
//   options: props => {
//     const {
//       item,
//     } = props;
//     if (!item) {
//       return {
//         skip: true,
//       }
//     }
//     const {
//       Caller: {
//         id: callerId,
//       },
//     } = item;
//     return {
//       // skip,
//       variables: {
//         where: {
//           id: callerId,
//         },
//       },
//     };
//   },
// })(withStyles(styles)(CallRequest));

CallRequestButton.propTypes = process.env.NODE_ENV !== "production" ? {
  item: _propTypes2.default.object.isRequired,
  classes: _propTypes2.default.object.isRequired,
  accept: _propTypes2.default.func.isRequired,
  reject: _propTypes2.default.func.isRequired // data: PropTypes.object.isRequired,

} : {};
exports.default = (0, _withStyles2.default)(styles)(function (props) {
  return _react2.default.createElement(CallRequestButton, props);
});